import axios from 'axios'

export const state = {
  branches: {},
  branch: {},
  deparments: {}
}

export const getters = {
  listBranches (state) {
    return state.branches
  },
  detailBranch (state) {
    return state.branche
  },
  listDepartments (state) {
    return state.deparments
  },
}

export const mutations = {
  SET_BRANCHES (state, branches) {
    state.branches = branches
  },
  SET_BRANCHE (state, branche) {
    state.branche = branche
  },
  SET_DEPARTMENT (state, deparments) {
    state.deparments = deparments
  },
  TOGGLE_SHOW_DETAIL (state, id) {
    state.branches.data.forEach((item, index) => {
      if (item.id === id) {
        item._showDetails = !item._showDetails;
        state.branches.data.splice(index, 1)
        state.branches.data.splice(index, 0, item)
      }
    });
  }
}

export const actions = {
  getBranches({ commit }, params = {}) {
    return axios.get(`/branches/search`, { params }).then(({ data }) => {
      return commit('SET_BRANCHES', data)
    })
  },
  getListBranches({ commit }, params = {}) {
    return axios.get(`/branches/search`, { params })
  },
  getDepartments({ commit }, params = {
    orderBy: 'id',
    sortedBy: 'desc',
    limit: 500,
  }) {
    return axios.get(`/departments/search`, { params }).then(({ data }) => {
      return commit('SET_DEPARTMENT', data)
    })
  },
  getListDepartments({ commit }, params = {}) {
    return axios.get(`/departments/search`, { params })
  },
  createBranch({ commit }, data) {
    return axios.post('/branches', data)
  },
  updateBranch({ commit }, branch) {
    const data = {
      name: branch.name,
      status: branch.status,
      departments: branch.departments ? branch.departments.map(item => item.name) : [],
      contact: branch.contacts,
      address: {
        line_1: branch.address.line_1,
        suburb: branch.address.suburb,
        city: branch.address.city,
        state: branch.address.state,
        postcode: branch.address.postcode,
        country_id: branch.address.country_id,
        types: branch.address.types ? branch.address.types.map(type => type.name) : [],
      }
    }
    return axios.put(`/branches/${branch.id}`, data)
  },
  getBranch({ commit }, id) {
    return axios.get(`/branches/${id}`);
  },
  exportBranchesCsv({commit}, params = {}) {
    return axios.get('/branches/export', {params});
  },
  toggleDataDetailsBranch: function({commit}, index) {
    return commit('TOGGLE_SHOW_DETAIL', index)
  },
  importBranch({commit}, params = {}) {
    const formData = new FormData()
    formData.append('file', params.file, params.file.name)
    formData.append('type', params.type)
    formData.append('force_save', params.force_save)
    formData.append('download_error', params.download_error)
    const responseType = params.download_error ? 'blob' : 'json'
    return axios.post('/branches/import', formData, {responseType: responseType})
  },
  downloadImportBranchesTemplate({ commit }, params = {} ) {
    return axios.get(`/import/branch/download-template`, {responseType: 'blob'})
  },
}
